import React, { useContext, useState } from 'react';
import { StackmatTimerDebug } from '../components/StackmatTimerDebug';
import { CubeCtx } from '../components/BluetoothCubeProvider';
import { StackmatState } from '../components/services/ICubingService';

export const StackmatTimerTestPage: React.FC = () => {
  const { selectService, getService, serviceType } = useContext(CubeCtx);
   const [state, setState] = useState<StackmatState | null>(null);
   const [isRunning, setRunning] = useState(false);
   const [error, setError] = useState<string | null>(null);
 
   const service = getService(); // now kept inside the component function

  return (
    <>
      {!!service && <StackmatTimerDebug key={serviceType} service={service} />}
    </>
  );
};
